import React from "react";

import { graphql, useMutation } from "react-relay";
import { IntegrationTurnpikeCreateScreenMutation } from "./__generated__/IntegrationTurnpikeCreateScreenMutation.graphql";
import { useAlert } from "../../common/Alert";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { IntegrationLogo } from "./components/Logos/Logos";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";

export const IntegrationTurnpikeCreateScreen = (props: {
  navigation: StoreAdminNavigationProp<"IntegrationTurnpikeCreate">;
}) => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const isValid = email.length > 1 && password.length > 1;

  const [create, createInFlight] =
    useMutation<IntegrationTurnpikeCreateScreenMutation>(graphql`
      mutation IntegrationTurnpikeCreateScreenMutation(
        $email: String!
        $password: String!
      ) {
        store {
          activateIntegrationTurnpike(password: $password, email: $email) {
            ... on ActivateTurnpikeSuccess {
              integrationTurnpike {
                id
              }
              __typename
            }

            ... on ActivateTurnpikeFailure {
              message
              __typename
            }
          }
        }
      }
    `);

  const Alert = useAlert();

  const activate = () => {
    create({
      onCompleted: (d) => {
        if (
          d.store.activateIntegrationTurnpike?.__typename ===
          "ActivateTurnpikeSuccess"
        ) {
          props.navigation.goBack();
        } else {
          Alert.alert(
            "Fel Uppstod",
            d.store.activateIntegrationTurnpike.__typename ===
              "ActivateTurnpikeFailure"
              ? d.store.activateIntegrationTurnpike.message
              : "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt användaruppgifter"
          );
        }
      },
      variables: {
        password,
        email,
      },
    });
  };

  return (
    <IntegrationActivateScreen
      onActivate={activate}
      isValid={isValid}
      isActivating={createInFlight}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="turnpike" />}
          description=""
        />
      }
      activation={
        <>
          <IntegrationActivateScreen.Input
            value={email}
            onChangeText={setEmail}
            type="email"
          />
          <IntegrationActivateScreen.Input
            value={password}
            onChangeText={setPassword}
            type="password"
          />
        </>
      }
    />
  );
};
